import React from "react";
import { motion } from "framer-motion";
import { SearchX, Smartphone, MousePointerBan } from "lucide-react";

const POINTS = [
    {
        icon: SearchX,
        title: "Invisible sur Google",
        desc: "Vos clients tapent « plombier Paris 15 » et c'est votre concurrent qui ressort. Vous n'existez nulle part dans les résultats locaux.",
    },
    {
        icon: Smartphone,
        title: "Pas adapté mobile",
        desc: "8 clients sur 10 vous cherchent depuis leur téléphone. S'ils pincent pour zoomer, ils sont déjà partis chez un autre artisan.",
    },
    {
        icon: MousePointerBan,
        title: "Aucun appel à l'action",
        desc: "Un numéro planqué en bas de page et aucun formulaire clair. Résultat : les visiteurs repartent sans vous appeler.",
    },
];

export default function PainPoints() {
    return (
        <section
            id="pain-points"
            className="relative bg-[#EEF2FB] text-[#1A1A2E] py-24 md:py-32"
            data-testid="painpoints-section"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="max-w-3xl">
                    <span className="inline-flex items-center gap-2 rounded-full bg-[#1A1A2E]/5 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#1A1A2E]/60">
                        Le diagnostic
                    </span>
                    <h2
                        className="mt-6 font-display font-bold tracking-tight text-balance"
                        style={{ fontSize: "clamp(32px, 5vw, 52px)", lineHeight: 1.05 }}
                        data-testid="painpoints-title"
                    >
                        La plupart des sites d'artisans ne servent à rien.
                        <span className="text-[#2B7BE4]"> Voilà pourquoi le vôtre va être différent.</span>
                    </h2>
                    <p className="mt-6 text-lg text-[#1A1A2E]/70 leading-relaxed max-w-2xl">
                        La plupart des sites d'artisans tombent dans les mêmes pièges.
                        Si au moins un de ces points vous parle, votre site ne travaille pas pour vous.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {POINTS.map((p, i) => (
                        <motion.article
                            key={p.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                            className="group relative rounded-2xl bg-white border border-[#1A1A2E]/5 p-8 shadow-[0_8px_30px_rgba(26,26,46,0.04)] hover:shadow-[0_24px_60px_rgba(26,26,46,0.08)] transition-all duration-500 hover:-translate-y-1"
                            data-testid={`painpoint-${i}`}
                        >
                            <div className="inline-flex size-12 items-center justify-center rounded-xl bg-[#2B7BE4]/10 text-[#2B7BE4]">
                                <p.icon size={22} strokeWidth={2} />
                            </div>
                            <h3 className="mt-6 font-display text-xl md:text-2xl font-bold tracking-tight">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-[15px] text-[#1A1A2E]/70 leading-relaxed">
                                {p.desc}
                            </p>
                            <div className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#1A1A2E]/40">
                                <span className="h-px w-6 bg-[#1A1A2E]/20" />
                                Symptôme {String(i + 1).padStart(2, "0")}
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
